<template>
  <div v-if="this.songs.length > 0">
    <div class="md-layout md-gutter">
      <div class="md-layout-item scrollmenu">
        <div style="min-height: 30px">
          <a href="#playlist-songs" v-for="(v, key) in this.songs" :index="key" :key="key"
             @click="addSong(v.track.id, v.track.name, v.track.artists[0].name)">
            <b>{{ v.track.name }}</b>
            <span>
               by {{ v.track.artists[0].name }},
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "../../firebaseInit";
import {addSongToSpotify} from "../../services/spotify";

export default {
  name: "RecentlyPlayed",
  mounted: function () {
    this.recentlyPlayed();
  },
  data() {
    return {
      songs: []
    }
  },
  methods: {
    async addSong(songId, songName, songArtist) {
      await addSongToSpotify(this.$route.params.user_id, this.$route.params.playlist_id, songId, songName, songArtist)
      this.$root.$emit('refreshPlaylist')
    },
    recentlyPlayed() {
      firebase
          .functions(process.env.VUE_APP_API_ENDPOINT)
          .httpsCallable("api/v1/recently-played")({
            user_id: this.$route.params.user_id,
          })
          .then((r) => {
            if (r.data.length > 0) {
              this.songs = r.data
            }
          })
          .catch((e) => {
            console.log(e)
            //this.$alert(e, "Error", "error");
          });
    },
  }
}
</script>

<style scoped>
div.scrollmenu {
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}
</style>
